import React from "react";

export default class DpcCategoria extends React.Component {
    render(){
        return (
            <article className="card-wrapper">
                <div className="card">
                    <div className="card-body">
                        <div className="category-top">
                            <a className="category" href={this.props.categoriaLink}>{this.props.categoria}</a>
                            <span className="data">{this.props.data}</span>
                        </div>
                        <h2 className="card-title">{this.props.title}</h2>
                        <p className="card-text">{this.props.content}</p>
                    </div>
                </div>
            </article>
        );
    }
}